"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.duplicateObject = void 0;
const underscore_1 = __importDefault(require("underscore"));
const generators_1 = require("../commonUtils/generators");
const duplicateObject = (_id, data) => {
    if (underscore_1.default.isArray(data)) {
        let newArray = [];
        for (const element of data) {
            const result = (0, exports.duplicateObject)(_id, element);
            if (result) {
                if (Array.isArray(result)) {
                    newArray = newArray.concat(result);
                }
                else {
                    newArray.push(result);
                }
            }
            else {
                newArray.push(element);
            }
        }
        return newArray;
    }
    if (underscore_1.default.isObject(data)) {
        if (data._id === _id) {
            // Duplicate the object
            const copy = underscore_1.default.clone(data);
            copy._id = (0, generators_1.getNewId)(_id);
            return [underscore_1.default.clone(data), copy];
        }
        const result = underscore_1.default.mapObject(data, (value) => {
            return (0, exports.duplicateObject)(_id, value);
        });
        return result;
    }
    return data;
};
exports.duplicateObject = duplicateObject;
